import React, { useState, useEffect, useCallback } from 'react';
import { productService } from '../../../services/productService';
import ProductList from '../components/ProductList';
import FilterSidebar from '../../../components/FilterSidebar';
import { useCart } from '../../../stores/cartStore';
import { useToast } from '../../../contexts/ToastContext';

const ProductCatalogPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortBy, setSortBy] = useState('popularity');
  
  const { addToCart } = useCart();
  const { addToast } = useToast();

  // Load initial data
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [categoriesData, brandsData] = await Promise.all([
          productService.getCategories(),
          productService.getBrands()
        ]);
        setCategories(categoriesData);
        setBrands(brandsData);
      } catch (error) {
        console.error('Error loading initial data:', error);
      }
    };

    loadInitialData();
  }, []);

  // Load products when filters or sorting change
  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        const result = await productService.getProducts({
          ...filters,
          sortBy
        });
        setProducts(result.products);
      } catch (error) {
        console.error('Error loading products:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [filters, sortBy]);

  const handleFiltersChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  const handleSortChange = (newSortBy) => {
    setSortBy(newSortBy);
  };

  const handleAddToCart = (product) => {
    addToCart(product);
    addToast(`${product.name} added to cart!`, 'success');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Product Catalog</h1>
          <p className="text-gray-600">Discover our amazing collection of products</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Filters Sidebar */}
          <div className="lg:w-1/4">
            <div className="sticky top-4">
              <FilterSidebar
                onFiltersChange={handleFiltersChange}
                categories={categories}
                brands={brands}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:w-3/4">
            <ProductList
              products={products}
              onAddToCart={handleAddToCart}
              loading={loading}
              sortBy={sortBy}
              onSortChange={handleSortChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCatalogPage;
